import { computed, type Ref } from 'vue'

export function useSortedOutputs<T extends { id?: string }>(
  outputRef: Ref<{ outputs?: T[] } | undefined>
) {
  return computed(() =>
    [...(outputRef.value?.outputs ?? [])].sort((a, b) =>
      (a.id ?? '').localeCompare(b.id ?? '', undefined, { numeric: true, sensitivity: 'base' })
    )
  )
}